import { InputAdornment, TextField, TextFieldProps } from '@mui/material'
import SearchIcon from '../../assets/our-dealer/our-dealer-search.png'
import { Image } from 'antd'
import { useTranslation } from 'react-i18next'

export const SearchBar: React.FC<TextFieldProps> = (props) => {

  const { t } = useTranslation()

  return (
    <TextField
      fullWidth
      placeholder={props?.placeholder || t('t389')}
      InputProps={{
        style: {
          borderRadius: '10px',
          borderColor: '#E4E7ED',
        },
        startAdornment: (
          <InputAdornment position='start'>
            <Image src={SearchIcon} width={20} height={20} alt='' preview={false}></Image>
          </InputAdornment>
        ),
        ...props?.InputProps,
      }}
      inputProps={{
        sx: {
          paddingBlockEnd: '12px',
        },
        ...props?.inputProps,
      }}
      {...props}
    />
  )
}

export default SearchBar
